<template>
  <div :class="{ 'mt-3': !isSmall, 'me-2': isSmall }" v-if="showHistory && id">
    <h3 class="fw-semibold fs-5" v-if="!isSmall">
      История движения
      <button type="button" class="btn btn-sm m-2 btn-more-bg" @click="onGetMore">
        <i class="bi bi-list-columns-reverse" />
        Посмотреть
      </button>
    </h3>

    <!--  маленькая кнопка для истории обращений-->
    <button class="ms-auto btn btn-secondary" @click="onGetMore" v-if="isSmall">
      <i class="bi bi-justify-left" />
    </button>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import config from '@/config'
import { url } from '@/lib/history'
import { useApi } from '@provise/composables/api'
import { useModalStack } from '@provise/stores/modalstack'
import ModalWindow from '@/components/history/modal.vue'

const { push: openModal } = useModalStack()

const showHistory = config.VITE_SHOW_HISTORY === 'false' ? false : true
const props = defineProps({
  model: String,
  id: Number,
  isSmall: Boolean,
})

const watch = computed(() => url(props.model, props.id))
const { model: histModel, refresh } = useApi({
  url: watch,
  watch,
  data: {},
})

defineExpose({ refresh })

async function onGetMore() {
  await refresh()
  openModal({
    component: ModalWindow,
    props: {
      modelName: props.model,
      modelId: props.id,
      headerText: 'Вся история',
      list: histModel.value.data,
    },
  })
}
</script>
